import { useCallback, useEffect, useState } from "react";
import {
  registerActivityScheduleListener,
  type ActivityScheduleDraft,
} from "@/lib/activityScheduleBridge";
import { ActivityCreateModal } from "@/components/activities/ActivityCreateModal";

/**
 * Single app-wide host for "schedule next activity" prompts (after complete / deal won).
 * Mounted once under the authenticated tree.
 */
export function GlobalActivityScheduleModal() {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState<ActivityScheduleDraft | null>(null);

  useEffect(() => {
    registerActivityScheduleListener((d) => {
      setDraft(d);
      setOpen(true);
    });
    return () => registerActivityScheduleListener(null);
  }, []);

  const onOpenChange = useCallback((next: boolean) => {
    setOpen(next);
    if (!next) setDraft(null);
  }, []);

  return (
    <ActivityCreateModal
      open={open}
      onOpenChange={onOpenChange}
      preselectedLeadId={draft?.leadId || undefined}
      preselectedDealId={draft?.dealId || undefined}
      preselectedCompanyId={draft?.companyId || undefined}
      preselectedOwnerId={draft?.ownerId || undefined}
      preselectedType={draft?.activityTypeKey || undefined}
      preselectedDateTime={draft?.scheduledFor || undefined}
    />
  );
}
